import { useState } from "react";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import { useNavigate } from "react-router-dom";
import { ArrowOutwardRounded, ChatBubbleOutlineOutlined, MoreVert, Visibility } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import dayjs from "dayjs";

const ClientDetailsTableRow = ({
  id,
  image,
  name,
  country,
  notes,
  screener,
  sessions,
  type,
  worksheets,
  onClickCallback,
  onReschedule,
  onAddNote,
  onPrescription,
  onCancel,
  onAddSessionNote,
  data
}) => {
  const selectedRowClass = "SelectedTableRow";
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRowClick = () => {
    if (onClickCallback) {
      onClickCallback(name, id, image, country, notes, screener, sessions, type, worksheets);
    }
  };

  const onChat = () => {
    navigate(`/expert/chat?patientID=${id}&patientName=${name}&type=redirect`);
  };

  const onCourseUnderTaken = () => {
    navigate(`/expert/patients?patient=${name}&id=${id}&tabIndex=3`)
  }

  console.log("Data ::::: ", data)


  const normalizeDate = (date) => {
    // Handle null, undefined, or empty values
    if (!date) {
      return null;
    }

    // Try to parse the date with dayjs using different strategies
    let parsedDate = dayjs(date);
    
    // If first attempt fails, try parsing as DD-MM-YYYY format explicitly
    if (!parsedDate.isValid() && typeof date === 'string') {
      // Check if it matches DD-MM-YYYY pattern (e.g., "14-01-1995")
      const ddMmYyyyPattern = /^(\d{1,2})-(\d{1,2})-(\d{4})$/;
      const match = date.match(ddMmYyyyPattern);
      
      if (match) {
        const [, day, month, year] = match;
        // Create date with explicit format: YYYY-MM-DD
        parsedDate = dayjs(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`);
      }
    }
    
    // Check if the parsed date is valid
    if (!parsedDate.isValid()) {
      return null;
    }

    // Return formatted date in DD-MM-YYYY format
    return parsedDate.format("DD-MM-YYYY");
  }

  return (
    <TableRow
      className={`ClientDetails--TableRow`}
      sx={{
        backgroundColor: "#FFF",
        "&:last-child td, &:last-child th": { border: 0 },
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "#f5f5f5"
        }
      }}
      onClick={handleRowClick}
    >
      <TableCell>
        <img
          src={image}
          width={45}
          height={45}
          style={{ borderRadius: "50%", objectFit: "cover", objectPosition: "top" }}
        />
      </TableCell>
      <TableCell className="Table--Name">
        <div>
          <p>{name}</p>
          <span>{country}</span>
        </div>
      </TableCell>

      <TableCell className="Table--Sessions">
        <p>{sessions}</p>
      </TableCell>
      <TableCell className="Table--Sessions">
        <p>{data?.email || "-"}</p>
      </TableCell>
      <TableCell className="Table--Sessions">
        <p>{data?.MobileNo || "-"}</p>
      </TableCell>
      <TableCell className="Table--Sessions">
        <p>{normalizeDate(data?.DOB) || "-"}</p>
      </TableCell>

      {/* <TableCell className="Table--Screener">
        <p>{screener}</p>
      </TableCell> */}
      {/* <TableCell className="Table--SessionNotes">
        <p>{notes}</p>
      </TableCell> */}

      {/* <TableCell className="Table--Worksheets">
        <p>{worksheets}</p>
        
      </TableCell> */}
      <TableCell align="right">
        <div className=" w-100 d-flex justify-content-end gap-2">
          <Button

            variant="text"
            sx={{
              borderRadius: '20px', // Rounded but not too much
              bgcolor: '#e5e5e5',
              color: '#414141',
              fontSize: '14px', // 14px as in the default theme
              textTransform: 'capitalize',
              '&:hover': {
                background: "#e5e5e5"
              }
            }} className="d-flex py-1 justify-content-center align-items-center gap-2 rounded-3 px-3 py-0"
             onClick={()=>{
              window.open(`https://copilot.asksam.com.au/clinical/patients?client=${name}&id=${id}`, '_blank')
             }}>
            <ArrowOutwardRounded />
            View In Copilot
          </Button>
          {/* <Button

            variant="text"
            sx={{
              borderRadius: '20px', // Rounded but not too much
              bgcolor: '#f5f5f5',
              color: '#414141',
              fontSize: '14px', // 14px as in the default theme
              textTransform: 'capitalize',
              '&:hover': {
                background: "#f5f5f5"
              }
            }} className="d-flex py-1 justify-content-center align-items-center gap-2 rounded-3 px-3 py-0" onClick={handleRowClick}>
            <Visibility />
            View
          </Button>

          <Button

            variant="text"
            sx={{
              borderRadius: '20px', // Rounded but not too much
              bgcolor: '#f5f5f5',
              color: '#414141',
              fontSize: '14px', // 14px as in the default theme
              textTransform: 'capitalize',
              '&:hover': {
                background: "#f5f5f5"
              }
            }} className="d-flex py-1 justify-content-center align-items-center gap-2 rounded-3 px-3 py-0" onClick={onChat}>
            <ChatBubbleOutlineOutlined />
            Chat
          </Button> */}



          {/* <Tooltip title="More Options">
            <IconButton
              onClick={handleClick}
              aria-controls={open ? "demo-positioned-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <MoreVert />
            </IconButton>
          </Tooltip> */}

          <Menu
            id="demo-positioned-menu"
            aria-labelledby="demo-positioned-button"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            className="DarkDropdown"
          >
            {/* <MenuItem sx={{ fontSize: "14px" }} onClick={onAddNote}>
              Add Note
            </MenuItem>
            <Divider />
            <MenuItem sx={{ fontSize: "14px" }} onClick={onAddSessionNote}>
              Add Session Note
            </MenuItem> */}

            {/* <MenuItem sx={{ fontSize: "14px" }}>Book Appointment</MenuItem> */}
            <Divider />

            <MenuItem sx={{ fontSize: "14px" }} onClick={onReschedule}>
              Reschedule
            </MenuItem>
            <Divider />
            {/* <MenuItem sx={{ fontSize: "14px" }} onClick={onPrescription}>
              Add Presciptions
            </MenuItem> */}
            <Divider />
            <MenuItem sx={{ fontSize: "14px" }} onClick={onCourseUnderTaken}>Courses Undertaken</MenuItem>

          </Menu>
        </div>
      </TableCell>
    </TableRow>
  );
};

export default ClientDetailsTableRow;
